export default {
  props: {
    type: {
      type: String,
      default: 'flipping-square',
    },
    elements: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    window.App.$on('grid.fetching', grid => {
      this.visible = true;
    });
    window.App.$on(['grid.fetch-error', 'grid.fetched'], grid => {
      this.visible = false;
    });
  }
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/assets/js/theme-mixins/DataGridLoader.js